<template>
    <v-navigation-drawer
        v-model="reactiveValue"
        disable-resize-watcher
        disable-router-watcher
        right
        fixed
        temporary
        tag="div"
        :width="width"
    >
        <v-card class="d-flex flex-column" height="100%">
            <v-card-title class="py-2">
                {{ title }}
            </v-card-title>
            <v-card-text class="pt-4 flex-grow-1 fields-container">
                <slot name="content">
                    <div>No filters available...</div>
                </slot>
            </v-card-text>
            <v-card-actions class="px-3 justify-end">
                <v-btn
                    outlined
                    color="accent"
                    small
                    :disabled="disableClear"
                    @click="onClearAllClick"
                    >Clear All</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn outlined small @click="onCancelClick">Cancel</v-btn>
                <v-btn
                    color="primary"
                    small
                    :disabled="disableApply"
                    @click="onApplyClick"
                    >Apply</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-navigation-drawer>
</template>

<script>
export default {
    name: 'RightFilterDrawer',
    props: {
        value: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: false,
            default: 'Filters'
        },
        width: {
            type: Number,
            required: false,
            default: 300
        },
        disableApply: {
            type: Boolean,
            required: false,
            default: false
        },
        disableClear: {
            type: Boolean,
            required: false,
            dafault: false
        }
    },
    computed: {
        reactiveValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        }
    },
    watch: {
        value(newValue) {
            if (newValue) {
                this.$el.querySelector('.v-input input').focus();
            } else {
                this.$el.parentElement
                    .querySelector('.more-data-filters')
                    .focus();
            }
        }
    },
    methods: {
        // ==================== Events ===================
        onCancelClick() {
            this.$emit('cancel');
            this.reactiveValue = false;
        },
        onApplyClick() {
            this.$emit('apply');
            this.reactiveValue = false;
        },
        onClearAllClick() {
            this.$emit('clear');
            this.reactiveValue = false;
        }
    }
};
</script>

<style scoped lang="scss">
.v-navigation-drawer.theme--light {
    .v-card {
        background: map-get($deep-grey, 'lighten-7');
    }
}
.fields-container {
    overflow: auto;
}
</style>
